module.exports = __webpack_public_path__ + "static/media/ALPHA.33c2dd85.png";